import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  copyNewFormName: {
    id: 'jira-common.ListProjectForms.CopyText',
    defaultMessage: '{formName} copy',
    description: 'Adds the word copy to a duplicated form title'
  },
  duplicateLabel: {
    id: 'jira-common.ListProjectForms.Duplicate',
    defaultMessage: 'Duplicate',
    description: 'Label for the dropdown menu item, which duplicates a form'
  }
});